import axios from "axios";
import { getCookie } from "./utils";

const configURLS = {
  production: {
    // baseURL: "https://api.ogiso.io",
    baseURL: "https://api.ogiso.io",
    frontendURL:"https://www.ogiso.io",
    socketURL:"https://websocket.ogiso.io"
  },

  staging: {
    baseURL: "https://staging-api.ogiso.io",
    frontendURL: "https://staging.ogiso.io",
    socketURL:"https://staging-websocket.ogiso.io"
    //  baseURL:"http://18.217.220.75:5000"
  },
  test: {
    baseURL: "https://staging-api.ogiso.io",
  },
  local: {
    // baseURL: "http://192.168.100.17:5000",
    // baseURL: "https://sxcfrugsh3.execute-api.us-east-2.amazonaws.com",
    // baseURL: "http://192.168.18.26:5000",
    baseURL: "http://localhost:5000",
    // frontendURL: "http://192.168.18.26:3000",
    frontendURL: "http://localhost:3000",
    socketURL:"https://staging-websocket.ogiso.io"
    // baseURL: "http://192.168.100.29:3000",
    // baseURL: "http://192.168.100.23:5000",
    // baseURL: "http://192.168.100.6:5000",
  },
};

// Points to check before deployment:
// Change Firebase Project
// Change Base URL

// staging, production, local
const environment = "production";
export const Essential_Support_Note = "679cae7b2a9d98b98db57c26";
export const Intervention_Progress_Note = "68aefa50f94634ab806524eb";
export const Billing_Services_Note = "67c03f1744b56dc58c2504bb";
export const PROGRESS_Note =
  environment === "production"
    ? "65af568b51c7a9d2e590030f"
    : "65844ebc60e43ae42de946ff";
  
export const stripe_publishable_key =
  environment === "production"
    ? "pk_live_51NNJSEKXwso6muiRSzk4UrBvq1x0VfHKUxJWpGVxkvzG9CKKK5yOUTouZ0YIaRRaRWSZDU1DvhkVhc6VPMATxRio00e8oN3Ynp"
    : "pk_test_51NNJSEKXwso6muiRPuy7uaEFgbCb2OXPhPT52VG6UAOvRQjSMVoLpMzw6rWDaYnf0DdPgVllbpwx91GJVcHPuCgY00Etm8JTvf";
    
export const https = (TOKEN) => {
  const token = getCookie("token");
  return axios.create({
    baseURL: configURLS[environment].baseURL,
    headers: {
      Authorization: `Bearer ${token || TOKEN}`,
    },
  });
};

export const isStaff = (role) => {
  return role?.toLowerCase() === "staff";
};

const baseURL = configURLS[environment].baseURL;
const frontendURL = configURLS[environment].frontendURL;
const socketURL = configURLS[environment].socketURL;
export { baseURL, frontendURL,socketURL };
